const ranges = [
  { min: 0, max: 0.1, opacity: 0 },
  { min: 0.1, max: 0.2, opacity: 0.1 },
  { min: 0.2, max: 0.3, opacity: 0.2 },
  { min: 0.3, max: 0.7, opacity: 0.3 },
  { min: 0.7, max: 1.1, opacity: 0.4 },
  { min: 1.1, max: 1.5, opacity: 0.5 },
  { min: 1.5, max: 2, opacity: 0.6 },
  { min: 2, max: 5, opacity: 0.7 },
  { min: 5, max: 10, opacity: 0.8 },
  { min: 10, max: 15, opacity: 0.9 },
  { min: 15, opacity: 1 },
];

export function mapInteractionsToOpacity(number: number): number {
  for (const range of ranges) {
    if (
      range.min <= number &&
      (range.max === undefined || number <= range.max)
    ) {
      return range.opacity;
    }
  }
  throw new Error(`mapInteractionsToOpacity: Invalid number input ${number}`);
}
